import AppEntry from '@root/renters.joinroot.com/src/app-entry';
import CaptchaService from '@root/core/src/services/captcha-service';
import ErrorReportService from '@root/core/src/services/error-report-service';
import React from '@root/vendor/react';
import ReactDOM from '@root/vendor/react-dom';
import environment from '@root/core/src/utils/environment';
import { BrowserRouter } from '@root/vendor/react-router-dom';

const UNSUPPORTED_BROWSERS = ['Edge/17', 'Edge/18'];

const isUnsupportedBrowser = () => {
  for (const browser of UNSUPPORTED_BROWSERS) {
    if (window.navigator.userAgent && window.navigator.userAgent.indexOf(browser) >= 0) {
      return true;
    }
  }

  return false;
};

if (!Object.entries || !window.URLSearchParams || isUnsupportedBrowser()) {
  // eslint-disable-next-line root/prevent-use-of-window-location
  window.location.replace(`${environment.websiteBaseUrl}/app/`);
} else {
  CaptchaService.setup();
  ErrorReportService.init({ environment });

  ReactDOM.render(
    <AppEntry routerComponent={BrowserRouter} />,
    document.getElementById('root')
  );
}
